import React from "react";
import { useDispatch } from "react-redux";

import { Icon } from "../../../../../../components/icon/Icon";
import { openDeviceCreationByCodeDialog } from "../../AddDeviceByCode";
import { HelpLink } from "../../../../../../components/helpLink/HelpLink";
import { openDeviceCreationByMacDialog } from "../../AddDeviceByMac";

import "./DeviceCreationFlowSelector.scss";
import { useIntlTranslate } from "../../../../../../hooks";

interface DeviceCreationFlowSelectorProps {
  currentProfile: string;
}

interface FlowOptionProps {
  headerTranslationId: string;
  descriptionTranslationId?: string;
  linkTranslationId?: string;
  ariaLabelTranslationId: string;
  helpSection?: string;
  onClick: () => void;
}

export const DeviceCreationFlowSelector = ({
  currentProfile,
}: DeviceCreationFlowSelectorProps) => {
  return (
    <div className={"flow-selector"}>
      <CreateDeviceByCodeOption currentProfile={currentProfile} />
      <CreateDeviceByMacOption currentProfile={currentProfile} />
    </div>
  );
};

const CreateDeviceByCodeOption = ({ currentProfile }) => {
  const dispatch = useDispatch();
  const openNextDialog = () =>
    dispatch(openDeviceCreationByCodeDialog({ currentProfile }), {
      showLoader: false,
    });

  return (
    <FlowOption
      headerTranslationId={"device_creation_picker_header_by_code"}
      descriptionTranslationId={"device_creation_picker_description_by_code"}
      linkTranslationId={"where_to_find_code"}
      ariaLabelTranslationId={"aria_add_device_by_code"}
      helpSection={"changing-restrictions-for-unrecognized-devices"}
      onClick={openNextDialog}
    />
  );
};

const CreateDeviceByMacOption = ({ currentProfile }) => {
  const dispatch = useDispatch();
  const openNextDialog = () =>
    dispatch(openDeviceCreationByMacDialog({ currentProfile }), {
      showLoader: false,
    });

  return (
    <FlowOption
      headerTranslationId={"device_creation_picker_header_by_mac"}
      ariaLabelTranslationId={"aria_add_device_by_mac"}
      onClick={openNextDialog}
    />
  );
};

const FlowOption = ({
  headerTranslationId,
  descriptionTranslationId,
  linkTranslationId,
  ariaLabelTranslationId,
  helpSection,
  onClick,
}: FlowOptionProps) => {
  const translate = useIntlTranslate();

  return (
    <button
      className={"flow-option"}
      onClick={onClick}
      aria-label={translate(ariaLabelTranslationId)}
    >
      <div className={"flow-option__content"}>
        <h3 className={"flow-option__header"}>
          {translate(headerTranslationId)}
        </h3>
        {descriptionTranslationId && (
          <div className={"flow-option__description"}>
            {translate(descriptionTranslationId)}
          </div>
        )}
        {helpSection && (
          <HelpLink section={helpSection}>
            {translate(linkTranslationId)}
          </HelpLink>
        )}
      </div>
      <div className={"flow-option__icon"}>
        <Icon />
      </div>
    </button>
  );
};
